import React, { useCallback } from 'react'
import {  useDispatch } from 'react-redux'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { useForm } from '../../../hooks'
import { createMechandiseItem } from '../../actions'
import { useGetLineItemsbyInvoiceId } from '../../hooks/useGetLineItemsbyInvoiceId'
import { createLineItemMsgStructure } from '../../util/itemsTabValidation'
import { TranslateContext } from '../TranslateContext'
import MerchandiseDetails from './merchandiseDetails'
import validate from 'validate.js'
import * as ActionTypes from '../../actions/actionTypes'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import AccordionInvoice from '@commonComponents/accordion/AccordianInvoice'

const MerchandiseLineItems = ({
  invoiceId,
  invoiceItemIndex,
  updateInvoiceDataById,
  fieldPattern,
  validateError,
  initItemsTabValidation,
  procedureList
}) =>{
  const dispatch = useDispatch()
  const lineItems = useGetLineItemsbyInvoiceId(invoiceId)
  const { isDMS, isImportShipment, isDisabled, declarationStatus } = useCurrentShipmentType()
  const { isLoading,saveForm }=useForm("")
  const { lineItem } = fieldPattern()?.items 
  const translate = React.useContext(TranslateContext).translate
   
  const getMerchandiseLineItemId=useCallback(async(length)=>{
    const response=await saveForm({ invoices: [{invoiceId,lineItems: [{merchandiseId: '',invoiceId,procedure:"1000"}]}]})
       if(response){
        let updateDefaultParams={}
        const isAgsExport=!isDMS && !isImportShipment
        if(isAgsExport)
          updateDefaultParams.procedure="1000"
        
        dispatch(createMechandiseItem(invoiceId,response.responseMessage,updateDefaultParams))
        if(isAgsExport)
          saveForm({"invoices":[{"invoiceId": invoiceId,"lineItems": [{"merchandiseId": response.responseMessage,"invoiceId": invoiceId,...updateDefaultParams}]}]},false)
        
        
        let lineItemErr = validate({[`invoiceId`]: invoiceId,[`merchandiseId`]:response.responseMessage,...updateDefaultParams}, lineItem() ) || {}
        lineItemErr = createLineItemMsgStructure(lineItemErr,invoiceItemIndex,length)
        dispatch({
          type: ActionTypes.UPDATE_VALIDATION_ERRORS,
          tabName:'items',
          payload:lineItemErr
        })        
    }
  },[dispatch,saveForm,createMechandiseItem,invoiceId,isDMS,isImportShipment])

  return (
    <React.Fragment>
      <AccordionInvoice
       initialiState={{[lineItems?.[0]?.['merchandiseId']]:true}} 
       keyName={"toggleLineItems"} 
       invoiceId={invoiceId}
       expandTitle={"OPEN_ALL_ITEMS"}
       collapseTitle={"CLOSE_ALL_ITEMS"}
      >
      {lineItems?.map((item, index) => (
        <MerchandiseDetails
          key={item.merchandiseId}
          id={item.merchandiseId}
          invoiceIndex={invoiceItemIndex}
          invoiceId={invoiceId}
          lineItemIndex={index}
          merchandiseId={item.merchandiseId}
          updateInvoiceDataById={updateInvoiceDataById}
          fieldPattern={fieldPattern}
          validateError={validateError}
          initItemsTabValidation={initItemsTabValidation}
          procedureList={procedureList}
          isDMS={isDMS}
          isImportShipment={isImportShipment} 
          isDisabled={isDisabled}
          declarationStatus={declarationStatus}
        />
      ))}
      </AccordionInvoice>
      {isLoading && <CustomLoader />}
     <AddBtn
     id={`add-line-items-${invoiceId}`}
    style={{ marginTop: '10px' }}
    onClick={()=>getMerchandiseLineItemId(lineItems?.length)}
    iconClass=""
    text={translate('ADD_LINE_ITEM', { ns: ['default', 'lineItem'] })}
    >
  </AddBtn>
      
    </React.Fragment>
  )
}

export default React.memo(MerchandiseLineItems) 
